import { Environment } from 'src/Environment';

import { request } from './request';
import { getUserId, getMerchantId } from './user.service';
import { parseObjectToQueryParamString } from 'src/helpers/functional-helpers';

// if this doesn't work add the details to sessionstorage rather
const retrievedRefunds = [];

export async function searchRefunds(
  abortController = null,
  fromDate,
  toDate,
  reference,
  fromAmount, // from and to amount are treated as cents by traderoot
  toAmount,
  pageNumber = 1,
  handleErrorResponse = null,
  showToastOnError = true,
  suppressTealiumEvent = false,
) {
  const userId = getUserId();
  const merchantId = getMerchantId();

  const queryParams = {
    userReference: userId,
    merchantID: merchantId,
  };

  if (!!fromDate && !!toDate) {
    queryParams.localTransactionFromDate = fromDate;
    queryParams.localTransactionToDate = toDate;
  }

  if (!!reference) {
    queryParams.retrievalReference = reference;
  }

  if (!!fromAmount) {
    queryParams.transactionFromAmount = Math.round(parseFloat(fromAmount) * 100);
  }

  if (!!toAmount) {
    queryParams.transactionToAmount = Math.round(parseFloat(toAmount) * 100);
  }

  if (!Environment.current?.disabledFeatures?.pagination) {
    queryParams.pageNumber = pageNumber;
  }

  const res = await request(
    `merchant/refunds?${parseObjectToQueryParamString(queryParams)}`,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController?.signal || null,
      },
    },
    null,
    null,
    showToastOnError,
    suppressTealiumEvent,
  );

  const isAborted = !!abortController && abortController.signal.aborted;
  if (res?.status === 200) {
    return res.result;
  } else if (res?.status === 204) {
    return [];
  } else if (handleErrorResponse && !isAborted) {
    handleErrorResponse('error response from the merchant/refunds GET endpoint', false);
  }
}

export async function getRefundDetails(
  abortController = null,
  recordId,
  terminalId,
  pan,
  handleErrorResponse = null,
  showToastOnError = true,
  suppressTealiumEvent = false,
) {
  const userId = getUserId();
  const res = await request(
    `merchant/refunds/retrieve?userReference=${userId}&id=${recordId}`,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController?.signal || null,
      },
    },
    null,
    null,
    showToastOnError,
    suppressTealiumEvent,
  );

  const isAborted = !!abortController && abortController.signal.aborted;
  if (res?.status === 200) {
    retrievedRefunds[recordId] = { ...res.result.data, terminalId: terminalId, PAN: pan };
    return res.result.data;
  } else if (handleErrorResponse && !isAborted) {
    handleErrorResponse('error response from the merchant/refunds/retrieve GET endpoint', true);
  }
}

export const notificationMap = {
  email: '03',
  sms: '01',
};

export async function submitRefund(
  amount,
  notificationType,
  notificationAddress,
  recordId,
  handleErrorResponse,
  methodOfPayment,
) {
  const userId = getUserId();
  const merchantId = getMerchantId();
  const refundDetails = retrievedRefunds[recordId];
  const res = await request(
    `merchant/refunds/edit`,
    {
      fetchOptions: {
        method: 'POST',
        body: JSON.stringify({
          userReference: userId,
          recordId: recordId,
          merchantID: merchantId,
          terminalID: refundDetails.terminalId,
          retrievalReference: refundDetails.retrievalReferenceNumber,
          methodOfPayment: refundDetails.methodOfPayment || methodOfPayment,
          accountType: refundDetails.accountType,
          currencyCode: refundDetails.currencyCode,
          transactionAmount: `${amount}`,
          pan: refundDetails.PAN,
          notificationAddress: notificationAddress,
          notificationType: notificationType,
          uuid: recordId, // this is not a required field on TR but DXL requires it
        }),
      },
    },
    null,
    null, // TealiumEvents.dashboardError,
    true,
  );

  if (handleErrorResponse && res?.status >= 500) {
    handleErrorResponse(
      'error response from the merchant/refunds/edit POST endpoint',
      true,
      false,
      res,
    );
  }

  return {
    ok: res?.status === 200,
    result: res?.status === 200 ? res?.result : null,
    error: res?.status >= 300 ? res?.result : null,
  };
}
